
































import {
    Vue, Component, Prop, PropSync, Mixins, Watch,
} from 'vue-property-decorator'
import filter from '@/common/filter'

@Component
export default class DateInput extends Vue {
    $refs: any

    @Prop({ default: '' }) value!: string

    @Prop({ default: false }) disabled!: boolean

    @Prop({
        default() {
            return {}
        }
    }) pickerOptions!: any

    text: string = ''

    tempVal: string = ''

    placeholder: string = 'dd/mm/yyyy'

    focused: boolean = false
    
    get preview() {
        let str = ''
        let d = this.tempVal.slice(0, 2)
        let m = this.tempVal.slice(2, 4)
        let y = this.tempVal.slice(4)
        if (d) {
            str = d + (d.length === 2 ? '/' : '')
        }
        if (m) {
            str = str + m + (m.length === 2 ? '/' : '')
        }
        if (y) {
            str = str + y
        }
        return str
    }

    get selectDate() {
        return this.value
    }

    set selectDate(val) {
        this.$emit('input',  val)
    }

    @Watch('value', { immediate: true })
    handleValueChange(val) {
        if (val) {
            this.tempVal = filter.dateFilter(val).replace(/\//g, '')
        } else {
            this.tempVal = ''
        }
    }

    focusInput() {
        this.$refs.input.focus()
    }

    deleteLatest() {
        this.tempVal = this.tempVal.slice(0, -1)
        if (!this.tempVal.length) {
            this.$emit('input', null)
        }
        this.$refs.input.dispatch('ElFormItem', 'el.form.change', []);
    }

    handleFocus() {
        this.focused = true
    }

    handleBlur() {
        this.focused = false
    }

    handleInput(val) {
        if (this.tempVal.length === 8) { // 8位了还在输入
            if (!Number.isNaN(+val)) {
                this.tempVal = this.tempVal.slice(0, -1)
            }
        }
        if (this.tempVal.length !== 8) {
            if (val) {
                if (!Number.isNaN(+val)) { // 只支持数字
                    this.tempVal += val
                    if (this.tempVal.length > 8) {
                        this.tempVal = this.tempVal.slice(0, 8)
                    }
                }
            } else {
                this.$emit('input', null) // 清空操作
            }
            if (this.tempVal.length === 8) {
                const date: any = this.validate()
                if (date) {
                    this.$emit('input', date.getTime())
                } else {
                    this.tempVal = ''
                    this.$emit('input', null)
                    this.$message.warning('Please enter a valid date')
                }
            }
        }
        this.text = ''
        this.$refs.input.dispatch('ElFormItem', 'el.form.change', []);
    }

    validate() {
        if (!this.tempVal.length) return true // 只有组件外部调validate会return true
        if (this.tempVal.length !== 8) return false
        let d = +this.tempVal.slice(0, 2)
        let m = +this.tempVal.slice(2, 4)
        let y = +this.tempVal.slice(4)
        let date = new Date(m + '/' + d + '/' + y)
        if (date.getFullYear() === y && (date.getMonth() + 1) === m && date.getDate() === d) { // 判断日期是否合法
            if (this.pickerOptions.disabledDate && this.pickerOptions.disabledDate(date)) {
                return false
            }
            return date
        } else {
            return false
        }
    }

}
